module.exports = __webpack_public_path__ + "static/media/search.312707b5.svg";